import { Out } from "@/infrastructure/frontent/clientMessage"

export const ConvertUtcStringToDateNullable = (utcDate: string) : Date | undefined  => {
    if ( utcDate === undefined || utcDate === null || utcDate.length < 10) return undefined
    utcDate = makeValidUtcString(utcDate)
    const result = new Date(utcDate)
    printDate("ConvertUtcStringToDateNullable" , result)
    return result
}

export const ConvertUtcStringToDate = (utcDate: string) : Date  => {
    if ( utcDate === undefined || utcDate === null || utcDate.length < 10) return newDate()
    utcDate = makeValidUtcString(utcDate)

    const result = new Date(utcDate)
    printDate("ConvertUtcStringToDate" , result)
    return result
}

export const ConvertUtcStringToDateTime = (utcDate: string) : Date | undefined  => { 

    try {
        if ( !utcDate || utcDate.length < 10) return undefined

        utcDate = makeValidUtcString(utcDate)

        const [datePart, timePart] = utcDate.split('T');
        const [year, month, day] = datePart.split('-');    
        const timePartWithoutZ = timePart.slice(0, -1); 
        const [hour, minute, second, _] = timePartWithoutZ.split(':');
    
        const result = new Date(Number.parseInt(year, 10), Number.parseInt(month, 10) - 1, Number.parseInt(day, 10), Number.parseInt(hour, 10), Number.parseInt(minute, 10), Number.parseInt(second, 10));
        return result;
    
    } catch(e) {
        try {
            return GenerateCorrectTime( ConvertUtcStringToDate(utcDate))
        } catch(e) {
            return undefined
        }
    }


}

export const ConvertUtcStringToDateOrUndefined = (utcDate: string) : Date | undefined  => {
    if ( utcDate === undefined || utcDate === null || utcDate.length < 10) return undefined
    utcDate = makeValidUtcString(utcDate)
    // if ( isUTCDay(utcDate)) {
    //     const utcResult = new Date(utcDate)
    //     utcResult.setDate(utcResult.getDate() - 1)
    //     return utcResult
    // }
    const result = new Date(utcDate)
    printDate("ConvertUtcStringToDateOrUndefined" , result)
    return result
}


const isUTCDay = (utcDate: string) : boolean => {
    try {
        const regex = /00:00:00\.000Z$/;
        return regex.test(utcDate);    
    } catch(e) {
        return false
    }
}



export const makeValidUtcString = (utc: string) : string => {
    if ( !utc) return utc
    utc = utc.trim().replace(" ", "T")
    if ( utc.length > 10 ) {
        const temp: string[] = utc.split(":")
        if ( temp.length === 4) {
            utc = temp[0] + ":" + temp[1] + ":" + temp[2] + "." + temp[3]
        }
    }

    return utc
}





export function correctDatePickerChange(e: any, id: string , dataItem: any, propName: string) :void {
    try {
        if(e.component.id == id ) {
            if(e.value != null && e.value != undefined && e.value != "") {
                const date = new Date( e.value )
                date.setHours(date.getHours() + 2)
                dataItem[propName] = date
                return
            }
    
            dataItem[propName] = null
        }       
    } catch (error) { 
        console.log(error)
    }
             
}

export function clearDatePickerValue(componentId: string, id: string, dataItem: any, propName: string) {
    if (componentId == id) {
        dataItem[propName] = null
    }
}

export function getCurrentDateTime() : Date {
    const date = new Date( )    
    return date
}


export function GenerateCorrectTime(date: Date) {    
    const result = date
    printDate("GenerateCorrectTime" , result)
    return result
}

export function newDate() {
    const result = new Date()    
    printDate("newDate" , result)
    return result
}

export function getCurrentDayDate() {
    const dateTime: Date = newDate()
    const result = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate())
    printDate("getCurrentDayDate" , result)
    return result
  }

  export function toLocalISOString(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Months are zero-based
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();

    // Format the local date and time as needed (e.g., YYYY-MM-DDTHH:MM:SS.mmm)
    const localISOString = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}.${String(milliseconds).padStart(3, '0')}`;

    

    return localISOString;
}

export function serializeToJson(obj: any) {
    var result = JSON.stringify(obj, dataReplacer);    
    return result;
}

function dataReplacer(key: string, value: any) : any {
    if ( isDate(value)) {
        return toLocalISOString(value);
    }
    try {
        if ( isValidUTCDate(value) ) {
            return toLocalISOString(new Date(value));
        }
    } catch(e) {
         Out.noOperation("")
    }    
    return value;
}

function isDate(value: any) : boolean {
    const isDate = value instanceof Date && !isNaN(value.valueOf());
    if (isDate) return true
    return false
}

function isValidUTCDate(value: string): boolean {
    // Check if the string matches the ISO 8601 format for UTC dates
    const utcDatePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
    if (!utcDatePattern.test(value)) {
        return false;
    }

    // Parse the date string
    const date = new Date(value);

    // Check if the date is valid
    return date instanceof Date && !isNaN(date.getTime());
}

export function printDate(functionName: string , currentDate: Date) {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; // Months are zero-based
    const day = currentDate.getDate();
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    const seconds = currentDate.getSeconds();


}